import { ReferralsPartners } from 'components/ReferralsPartners';
import { Page } from 'layouts/Page';
import { FC } from 'react';

export const ReferralsPartnersPage: FC = () => {
	return (
		<Page title="Referrals – EAS Control Center">
			<ReferralsPartners />
		</Page>
	);
};
